import { tratamentoComCannabisMedicinalCannect1 } from 'assets/img'

export const MockCardPodcast = {
  title: 'Cannabicast - Ep. 28: Canabinoides na outra text',
  text: 'Cannabicast 07 de mar. de 2023',
  audio:
    'https://anchor.fm/s/7cccdaa4/podcast/play/66967804/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-2-20%2F60294efa-9dee-cbf4-9776-21706986480a.mp3',
  image: tratamentoComCannabisMedicinalCannect1
}
